export default "__VITE_ASSET__mv$WEQp3__"